// extracted by mini-css-extract-plugin
export default {"custom_dialog":"CustomPopup_custom_dialog__pNRt1","custom_dialog_close":"CustomPopup_custom_dialog_close__RIdF0"};